import React from 'react'
import { ToastContentProps } from 'react-toastify';
import {ReactComponent as Alert2} from 'assets/svgs/alert_2.svg';
import {ReactComponent as Info} from 'assets/svgs/info.svg';
import {ReactComponent as CheckCircle} from 'assets/svgs/check-circle.svg';
import {ReactComponent as Error} from 'assets/svgs/cancel.svg';
import {ReactComponent as Close} from 'assets/svgs/clear.svg';
import classNames from 'classnames';

type Props<T> = {
    message: string
    title?: string;
} & ToastContentProps<T>
const Toast = <T,>(props: Props<T>) => {
    // props.toastProps.type === 'error'
    const {closeToast} = props;

    const getTitle = () => {
        if(props.title) {
            return props.title;
        } else if(props.toastProps.type === 'error') {
            return 'Error'
        } else if (props.toastProps.type === 'warning') {
            return 'Warning';
        } else if (props.toastProps.type === 'success') {
            return 'Success';
        } else if (props.toastProps.type === 'info') {
            return 'Info';
        }
    }

    const getColor = () => {
        if(props.toastProps.type === 'error') {
            return 'text-orange-error'
        } else if (props.toastProps.type === 'warning') {
            return 'text-yellow-secondary';
        } else if (props.toastProps.type === 'success') {
            return 'text-success';
        } else if (props.toastProps.type === 'info') {
            return 'text-primary';
        }
        return 'text-black'
    }

    const getIcon = () => {
        let item = null;
        if(props.toastProps.type === 'error') {
            item = <Error className="text-orange-error md:w-5 md:h-5 w-4 h-4"/>;
        } else if (props.toastProps.type === 'warning') {
            item =  <Alert2 className="md:w-5 md:h-5 w-4 h-4"/>;
        } else if (props.toastProps.type === 'success') {
            item =  <CheckCircle className="md:w-5 md:h-5 w-4 h-4"/>;
        } else if (props.toastProps.type === 'info') {
            item =  <Info className="text-primary md:w-5 md:h-5 w-4 h-4"/>;
        }
        return <div>{item}</div>;
    }
    
  return (
    <div className="flex gap-x-2 2xl:gap-x-4 items-start">
        {getIcon()}
        <div className="flex-1 -mt-1">
            <p className={classNames("font-acorn font-bold 2xl:text-[18px] text-[14px]", getColor())}>{getTitle()}</p>
            <p className="text-gray-subTextHint font-medium 2xl:text-[14px] text-[12px]">{props.message}</p>
        </div>
        <div onClick={closeToast}><Close/></div>
    </div>
  )
}

export default Toast;